import { ValuableModel } from '../../models/ValuableModel'

export class SchemaDateTimeModel extends ValuableModel {}

declare global {
  export interface RehajeViewModels {
    'Schema.DateTime': SchemaDateTimeModel
  }
}
